import { render, staticRenderFns } from "./SupportFab.vue?vue&type=template&id=0de77b84&scoped=true"
import script from "./SupportFab.vue?vue&type=script&lang=js"
export * from "./SupportFab.vue?vue&type=script&lang=js"
import style0 from "./SupportFab.vue?vue&type=style&index=0&id=0de77b84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de77b84",
  null
  
)

export default component.exports